module.exports = __webpack_public_path__ + "img/existing.44913362.png";